import * as token from "@universityofmaryland/web-token-library";
import * as typography from "@universityofmaryland/web-styles-library/typography";
import { jssToCSS } from "@universityofmaryland/web-utilities-library/styles";
import { createCompositeNavigationSlides } from "./slides.js";
import { createCompositeNavigationSliderAction } from "./action.js";
const ELEMENT_SLIDER_FIRST_SLIDE_CONTAINER = "nav-slider-first-slide-container";
const ELEMENT_SLIDER_FIRST_SLIDE_PRIMARY_LINKS_CONTAINER = "nav-slider-first-slide-primary-links-container";
const ELEMENT_SLIDER_SECONDARY_LINKS_CONTAINER = "nav-slider-secondary-links-container";
const ELEMENT_SLIDER_ADDITIONAL_CONTENT = "nav-slider-additional-content";
const OVERWRITE_ACTION_PRIMARY_CONTAINER = `.${ELEMENT_SLIDER_FIRST_SLIDE_PRIMARY_LINKS_CONTAINER} .${createCompositeNavigationSliderAction.Elements.container}`;
const OVERWRITE_ACTION_PRIMARY_LINK = `.${ELEMENT_SLIDER_FIRST_SLIDE_PRIMARY_LINKS_CONTAINER} .${createCompositeNavigationSliderAction.Elements.link}`;
const OverwriteSlidePrimaryLink = `
  ${jssToCSS({
  styleObj: {
    [`${OVERWRITE_ACTION_PRIMARY_LINK}`]: typography.sans.large
  }
})}

  ${OVERWRITE_ACTION_PRIMARY_LINK} {
    font-weight: 700;
    line-height: 1.3em;
  }
`;
const OverwriteSlidePrimaryContainer = `
  ${OVERWRITE_ACTION_PRIMARY_CONTAINER} {
    border-bottom: 1px solid ${token.color.gray.light};
    padding-bottom: ${token.spacing.md};
    margin-bottom: ${token.spacing.md};
  }
`;
const SecondaryLinksContainer = `
  .${ELEMENT_SLIDER_SECONDARY_LINKS_CONTAINER} .${createCompositeNavigationSliderAction.Elements.container}:last-child {
    border-bottom: 1px solid ${token.color.gray.light};
    padding-bottom: ${token.spacing.md};
  }
`;
const AdditonalContent = `
  .${ELEMENT_SLIDER_ADDITIONAL_CONTENT} {
    padding-top: ${token.spacing.md};
  }
`;
const STYLES_SLIDE_FIRST_ELEMENT = `
  ${SecondaryLinksContainer}
  ${AdditonalContent}
  ${OverwriteSlidePrimaryContainer}
  ${OverwriteSlidePrimaryLink}
`;
const createPrimaryLinks = (props) => {
  const container = document.createElement("div");
  const { primarySlideLinks } = props;
  if (!primarySlideLinks) return null;
  const links = Array.from(
    primarySlideLinks.querySelectorAll("a")
  );
  if (links.length > 0) {
    container.classList.add(ELEMENT_SLIDER_FIRST_SLIDE_PRIMARY_LINKS_CONTAINER);
    links.forEach(
      (link) => container.appendChild(createCompositeNavigationSliderAction.CreateElement({ ...props, link }))
    );
    return container;
  }
  return null;
};
const createSecondaryLinks = (props) => {
  const container = document.createElement("div");
  const { primarySlidesSecondaryLinks } = props;
  if (!primarySlidesSecondaryLinks) return null;
  const elements = Array.from(
    primarySlidesSecondaryLinks.querySelectorAll(":scope > *")
  );
  if (elements.length > 0) {
    container.classList.add(ELEMENT_SLIDER_SECONDARY_LINKS_CONTAINER);
    elements.forEach(
      (link) => container.appendChild(createCompositeNavigationSliderAction.CreateElement({ ...props, link }))
    );
    return container;
  }
  return null;
};
const createAdditonalContent = (element) => {
  const container = document.createElement("div");
  const { primarySlideContent } = element;
  if (!primarySlideContent) return null;
  container.classList.add(ELEMENT_SLIDER_ADDITIONAL_CONTENT);
  container.appendChild(primarySlideContent);
  return container;
};
const CreateSlideFirstElement = (props) => {
  const {
    setCurrentSlide,
    ATTRIBUTE_DATA_SLIDE,
    ATTRIBUTE_ACTIVE_SLIDE,
    isContextMenu
  } = props;
  const sliderContainer = document.createElement("div");
  const sliderOverflow = document.createElement("div");
  const wrapper = document.createElement("div");
  const primarlyLinkContent = createPrimaryLinks(props);
  const secondaryLinkContent = createSecondaryLinks(props);
  const additionalContent = createAdditonalContent(props);
  sliderContainer.classList.add(ELEMENT_SLIDER_FIRST_SLIDE_CONTAINER);
  sliderContainer.setAttribute(`${ATTRIBUTE_DATA_SLIDE}`, "");
  if (!isContextMenu) {
    sliderContainer.setAttribute(`${ATTRIBUTE_ACTIVE_SLIDE}`, "");
    setCurrentSlide({ element: sliderContainer });
  }
  if (primarlyLinkContent) wrapper.appendChild(primarlyLinkContent);
  if (secondaryLinkContent) wrapper.appendChild(secondaryLinkContent);
  if (additionalContent) wrapper.appendChild(additionalContent);
  wrapper.classList.add(createCompositeNavigationSlides.Elements.wrapper);
  sliderOverflow.classList.add(createCompositeNavigationSlides.Elements.overflow);
  sliderOverflow.appendChild(wrapper);
  sliderContainer.appendChild(sliderOverflow);
  return sliderContainer;
};
const createCompositeNavigationSliderFirst = {
  CreateElement: CreateSlideFirstElement,
  Styles: STYLES_SLIDE_FIRST_ELEMENT,
  Elements: {
    secondaryContainer: ELEMENT_SLIDER_SECONDARY_LINKS_CONTAINER
  }
};
export {
  createCompositeNavigationSliderFirst
};
//# sourceMappingURL=slide-first.js.map
